import { SubPage } from '../types';

export const FAN_SYSTEMS_SUB_PAGES: SubPage[] = [
    'basic',
    'commercial'
];
